/* tslint:disable */
export var icon = "\n<svg width=\"14\" height=\"7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 0H0v2h14V0zm0 5H0v2h14V5z\" fill=\"#C1E4FE\"/></svg>\n";
//# sourceMappingURL=new-list-view.svg.js.map